import Header from "components/Header";
import { useUserFeature } from "hooks/useUserFeature";
import MainLayout from "layouts/Main";
import NoneFactoringStatus from "./None";
import HaulPayPendingStatus from "./Pending";

export default function HaulPayStatus() {
  const { isFactoringApproved, isBroker } = useUserFeature();

  return isFactoringApproved === "pending" || isFactoringApproved === "declined" ? (
    <HaulPayPendingStatus />
  ) : (
    <MainLayout
      desktopTitle={isBroker ? "Factoring or Payments" : "Factoring"}
      customHeader={
        <Header label={isBroker ? "Factoring or Payments" : "Factoring"} isHideDesktop />
      }
      className="pl-3.5 pr-3.5">
      <NoneFactoringStatus />
    </MainLayout>
  );
}
